module.exports = __webpack_public_path__ + "img/systemAcFlow.7d7f75ff.gif";